module.exports = __webpack_public_path__ + "img/photo2.b241148d.jpg";